<template>
<div style="height: 100%;background-color:#fff;">
<div class="title">
    <strong @click="$router.push('/commission?index=2')"><i class="el-icon-back"></i></strong>
    <span>查看提成方案</span>
</div>

<!-- 基本信息-->
<el-row>
    <el-col><div class="base-info"><span class="line" ></span> <span>基本信息</span></div></el-col>
</el-row>
<el-form 
:model="form"  label-width="130px" class="demo-ruleForm">
    <el-form-item label="提成方案类型：" >
         <el-col class="text-simple" >{{form.planDetailName}}</el-col>
    </el-form-item>
      <el-form-item label="提成方案名称：" >
       <el-col class="text-simple">{{form.planName}}</el-col>
  </el-form-item>
  <el-form-item label="提成类型：" >
    <el-col class="text-simple" v-if="form.commissionType=='xftc'">消费提成</el-col>
    <el-col class="text-simple" v-if="form.commissionType=='cztc'">充值提成</el-col>
      </el-form-item>
    <!-- <el-form-item label="适用门店：" >
        <el-col class="text-simple">满品客大饭堂（习友路店）</el-col>
  </el-form-item> -->
  <el-form-item label="方案有效期：">
<el-col class="text-simple" v-if="form.effectiveType=='1'">永久有效</el-col>
<el-col class="text-simple" v-else>{{form.startDate}} 至 {{form.endDate}}</el-col>
  </el-form-item>
  <el-form-item label="创建人：">
    <el-col class="text-simple">{{form.creator}}</el-col>
  </el-form-item>
    <el-form-item label="方案创建时间：">
    <el-col class="text-simple">{{getTime(form.createDate)== 'NaN-NaN-NaN'? '' : getTime(form.createDate)}}</el-col>
  </el-form-item>
    <el-form-item label="修改人：">
    <el-col class="text-simple">{{form.updator}}</el-col>
  </el-form-item>
    <el-form-item label="方案修改时间：">
    <el-col class="text-simple">{{ getTime(form.updateDate)=='NaN-NaN-NaN'? '': getTime(form.updateDate)}} </el-col>
  </el-form-item>
</el-form>
<!-- 提成信息 -->
<el-row>
    <el-col><div class="base-info"><span class="line" ></span> <span>提成计算</span></div></el-col>
</el-row>
<el-form  label-width="130px" class="demo-ruleForm">

  <el-form-item label="桌台区域：" v-if="form.planType=='ddtc'">
    <el-col class="text-simple">{{form.areaClassList.map(item => item.tableAreaName).join(',')}}</el-col>
  </el-form-item>

  <el-form-item label="提成核算类型：" v-if="form.planType=='hyxgtc'">
    <el-col class="text-simple">{{calculateDetailTypeMap[form.calculateDetailType]}}</el-col>
  </el-form-item>

  <el-form-item label="提成计算方式：">
    <el-col class="text-simple">{{form.calculateTypeName}}</el-col>
  </el-form-item>

  <el-form-item label="详细计算规则：" v-if="form.planType=='mdyytc'">
    <el-col class="text-simple">{{calculateDetailTypeMap[form.calculateDetailType]}}</el-col>
  </el-form-item>

  <el-form-item label="提成菜品类型：" v-if="form.planType=='cptc'">
    <el-col class="text-simple">指定菜品</el-col>
  </el-form-item>


    <!-- <el-form-item label=" " v-if="form.calculateType=='agdjehbl'" >
      <div class="fourRadio" v-if="radio==1">
        <span>累计营业额 ≥</span>
          <el-input  maxlength=8  >
          <template slot="append">元</template>
          </el-input>
            <span style="margin-left:20px">总提成金额 ≥</span>
          <el-input maxlength=8  >
          <template slot="append">元</template>
          </el-input>
      </div>
            <div class="fourRadio" v-if="radio==2">
        <span>提成金额 = 总营业额 ×</span>
          <el-input  maxlength=3  >
          <template slot="append">%</template>
          </el-input>
      </div>
            <div class="fourRadio" v-if="radio==3">
        <span>累计营业额 ≥</span>
          <el-input  maxlength=8  >
          <template slot="append">元</template>
          </el-input><span> 时，</span>
            <span >总提成为超出部分的</span>
          <el-input maxlength=8  >
          <template slot="append">元</template>
          </el-input>
      </div>
            <div class="fourRadio" v-if="radio==4">
        <span>累计营业额 ≥</span>
          <el-input  maxlength=8  >
          <template slot="append">元</template>
          </el-input>
            <span style="margin-left:20px">每人提成金额：</span>
          <el-input maxlength=8  >
          <template slot="append">元</template>
          </el-input>
      </div>
  </el-form-item> -->

  <!-- 菜品提成分配 -->
  <el-form-item label="提成菜品：" class="table-width" v-if="form.planType=='cptc'">
    <el-table
      height="200"
      :data="form.productList"
      style="width: 100%;margin-top:8px">
      <el-table-column label="序号" fixed type="index" align="center"></el-table-column>
      <el-table-column
      align="center"
        prop="productName"
        label="菜品名称"
        >
      </el-table-column>
      <el-table-column
      align="center"
        prop="specification"
        label="菜品规格"
       >
      </el-table-column>
      <el-table-column
      align="center"
        prop="saleAmount"
        label="售卖价">
      </el-table-column>
            <el-table-column
            align="center"
        prop="royaltyAmount"
        label="提成金额（元）">
      </el-table-column>
    </el-table>
  </el-form-item>
  <el-form-item label="不予提成的业务：" v-if="form.freeDishFlag=='1' && form.planType=='cptc'">
    <el-col class="text-simple">赠菜</el-col>
  </el-form-item>

  <!-- 订单提成计算方式 -->
  <el-form-item label="每笔订单实付金额：" v-if="form.planType=='ddtc'">
    <div class="input-flex" v-for="item,i in form.rateList" :key="i" v-if="form.calculateType=='qjje'">
      <el-input placeholder="" v-model="item.minCriticalAmount" readonly>
        <template slot="prepend">满</template>
        <template slot="append">元</template>
      </el-input>
      <el-input placeholder="" v-model="item.royaltyAmount" readonly>
        <template slot="prepend">提成</template>
        <template slot="append">元</template>
      </el-input>
    </div>
    <div class="input-flex" v-for="item,i in form.rateList" :key="i" v-if="form.calculateType=='qjbl'">
      <el-input placeholder="" v-model="item.minCriticalAmount" readonly>
        <template slot="prepend">满</template>
        <template slot="append">元</template>
      </el-input>
      <el-input placeholder="" v-model="item.royaltyRate" readonly>
        <template slot="prepend">提成</template>
        <template slot="append">%</template>
      </el-input>
    </div>
  </el-form-item>

  <!-- 订单提成计算方式 -->
  <el-form-item label="每笔充值提成：" v-if="form.planType=='hyxgtc'">
    <el-input placeholder="" v-model="form.royaltyAmount" v-if="form.calculateType=='gdje'" readonly>
        <template slot="append">元</template>
    </el-input>
    <el-input placeholder="" v-model="form.royaltyRate" v-if="form.calculateType=='gdbl'" readonly>
      <template slot="append">%</template>
    </el-input>
    <div class="input-flex" v-for="item,i in form.rateList" :key="i" v-if="form.calculateType=='qjbl'">
      <el-input placeholder="" v-model="item.minCriticalAmount" readonly>
        <template slot="prepend">满</template>
        <template slot="append">元</template>
      </el-input>
      <el-input placeholder="" v-model="item.royaltyRate" readonly>
        <template slot="prepend">提成</template>
        <template slot="append">%</template>
      </el-input>
    </div>
  </el-form-item>

  <!-- 阶梯规则 -->
  <el-form-item label="设定营业额：" v-if="form.calculateType=='ajtjs' && form.calculateDetailType=='aljyyeccdbfjs'">
    <el-input placeholder="" v-model="form.criticalAmount" readonly>
        <template slot="append">元</template>
      </el-input>
  </el-form-item>
  <el-form-item label="阶梯规则：" v-if="form.calculateType=='ajtjs'">
    <div class="table-div">
      <div class="item" v-for="(item, i) in form.rateList">
          <div class="index">阶梯{{ i + 1 }}：</div>
          <div class="body">
            <div
              class=""
              v-html="
                `￥${
                  i == 0 ? '0' : form.rateList[i - 1].maxCriticalAmount
                } <&nbsp;营业额&nbsp;≤`
              "
            ></div>
            <div class="input-group first-step">
              <el-input
              readonly
                placeholder="请输入内容"
                maxlength="8"
                v-model="item.maxCriticalAmount"
                v-if="i + 1 != form.rateList.length"
              >
                <template slot="append">元</template>
              </el-input>
              <el-input placeholder="无限" v-else disabled class="last-input">
              </el-input>
            </div>
            <span style="margin-left: 6px; margin-right: 6px">,</span>
            <span style="margin-right: 6px"> 总提成金额 </span>
            <el-select
              v-model="item.commissionType"
              placeholder=""
              class="by-percent"
              disabled
            >
              <el-option value="2" label="按百分比"></el-option>
              <el-option value="1" label="按固定金额"></el-option>
            </el-select>
            <div class="input-group" v-if="item.commissionType == '2'">
              <input type="text" v-model="item.royaltyRate" />
              <div class="span">%</div>
            </div>
            <div class="input-group" v-if="item.commissionType == '1'">
              <input type="text" v-model="item.royaltyAmount" />
              <div class="span">元</div>
            </div>
          </div>
        </div>
      </div>
  </el-form-item>

  <el-form-item label="提成分配" v-if="form.planType=='mdyytc'">
    <el-radio v-model="form.allocationType" label="1">按指定员工分配</el-radio>
  </el-form-item>
  <el-form-item label="提成分配比例" v-if="form.planType=='mdyytc'">
      <el-table ref="form.allocateList" :data="form.allocateList" style="width:1000px">
        <el-table-column type="index" label="序号" :key="0"></el-table-column>
        <el-table-column :key="1" prop="userCode" label="账号"></el-table-column>
        <el-table-column :key="2" prop="userName" label="昵称"></el-table-column>
        <el-table-column :key="3" label="提成比例">
          <template slot-scope="scope">
            <el-input class="table-input" v-model="scope.row.allocateRate" readonly>
              <template slot="append">%</template>
            </el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-form-item>


</el-form>
<!-- <div class="foot">
       <el-button @click="$router.push('/commission')">取消</el-button>
    <el-button type="primary" @click="submitForm('ruleForm')">保存并创建</el-button>
</div> -->

</div>
</template>

<script>
 export default {
    data() {
      return {
        form:{
          merchantCode:"",
          merchantName:'',
          planType:'mdyytc',//单前页门店营业提成
          commissionType:'xftc',
          planTypeDetail: 'cpjgtc', //提成方案类型
          planName:'',//方案名称
          checkPeriodType:"my",//提成核算周期
          effectiveType:"1",//方案有效期
          startDate:"",
          endDate:'',
          calculateType:'agdjehbl',//提成计算方式
        
        },

        calculateDetailTypeMap:{
          "aljyyejs":"按累计营业额计算",
          "aljyyeccdbfjs":"按累计营业额超出的部分计算",
          "cebfgdje":"超额部分固定金额",
          "qbyyeabl":"全部营业额按比例",
          "cebfabl":"超额部分按比例",
          "dcmbhmrgdje":"达成目标后，每人固定金额",
          "adbbczje":"按单笔充值金额",
          "aljczje":"按累计充值金额",
        },


        tcfp:'1',//提成分配
        tcfpbl:'1',//提成分配比例
        syyg:'1',//适用员工
        dishType:'',
        input:'测试经营门店提成',
        tableData:[],
        checked:'',
        dateRange:[],
        dateRangeMonth:'',
        dateRangeWeeek:'',
        radio:"1",
        radio2:'',
        radio3:"",
      };
    },
    methods: {
      getTime(t){
        console.log(t)
        var data=new Date(t)
        console.log(data)
        var year=data.getFullYear()
        var mon=data.getMonth()+1
        var day=data.getDate()
        mon<10?  mon='0'+mon : mon
        day<10? day='0'+day : day
        return year+'-'+mon+'-'+day
        },

      queryOne(){
        this.$http.post('/merchantEmployeeRoyaltyPlan/queryOne',{
          planType:this.$route.query.type,
          planCode:this.$route.query.code
          }).then(res=>{
          console.log(res,'数据回显')
          this.form=res.data.data
          // 方案有效期
          if(res.data.data.effectiveType==0){
            this.dateRange[0]=res.data.data.startDate
            this.dateRange[1]=res.data.data.endDate
          }
        })
      }
    },
    created () {
      this.queryOne()
    }
  }
</script>

<style  lang="less" scoped>
.input-flex{
  display: flex;
  margin-bottom: 18px;
}

.table-div {
  color: #333;
  width: 1050px;
  background: #f8f8f8;
  padding: 24px 50px;
  box-sizing: border-box;
  border-radius: 2px;
  .add {
    font-size: 14px;
    color: #f59a23;
    cursor: pointer;
  }
  .item {
    display: flex;
    font-size: 14px;
    margin-bottom: 10px;
    .index {
      display: flex;
      justify-content: right;
      width: 100px;
      font-size: 14px;
      line-height: 32px;
    }
    .body {
      display: flex;
      width: 800px;
      position: relative;
      justify-content: right;
      line-height: 32px;
      .input-group {
        display: flex;
        border: 1px solid #e5e5e5;
        align-items: center;
        margin-left: 10px;
        background: #fff;
        border-radius: 4px;
        height: 28px;
        input {
          outline: none;
          border: none;
          width: 40px;
          background: #fff;
          padding: 4px 11px;
        }
        .span {
          padding-left: 10px;
          height: 100%;
          padding-left: 10px;
          padding-right: 10px;
          line-height: 32px;
          border: 1px solid #ddd;
          border-right: 0;
          background: #f8f8f8;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
  }
}

/deep/ .table-header-name{
  display: flex;
}
/deep/.fourRadio{
  height: 64px;
  background-color: #f8f8f8;
  width: 710px;
  padding: 24px 16px;
  padding-bottom: 0;
  span{
    color: #333;
  }
  .el-input.el-input--small.el-input-group.el-input-group--append{
    height: 30px;
    line-height: 28px;
    margin-left: 8px;
    width: 165px;
  }
  .el-input__inner{
    width: 126px;
  }
}
.title{
    padding: 6px 10px;
    height: 36px;
    border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span{
        margin-left: 10px;
    }
    i,span{
      font-size: 20px;
    font-weight: 500;
    }
}
    .line {
        display: inline-block;
        width: 3px;
        height: 15px;
        background-color: orange;
        margin-right: 5px;
        border-radius: 2px;
        margin-bottom: -2px;
    }
    .base-info{
        margin: 30px 0px 10px 20px;
    }
.foot{
    display: flex;
    justify-content: right;
    height: 100px;
    background-color: #fff;
    padding-right: 60px;
}
    // /deep/ .el-form {
    //     margin:10px 0 10px 40px;
    // }
    /deep/ .el-form-item__content{
        margin-left: 5px !important;
    }
    /deep/ .el-input__inner{
        width: 240px;
    }
/deep/ .el-form-item{
    display: flex;
}
/deep/ .text-simple{
    color: #606266;
}
/deep/ .el-radio__input.is-checked .el-radio__inner{
  border-color: #f59a23;
  background-color: #f59a23;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #606266;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
    border-color: #f59a23;
  background-color: #f59a23;
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #606266;
}
/deep/ .el-form-item__label{
  padding: 0;
}
/deep/ .table-width>div{
width: 89%;
}

/deep/ .input-flex .el-form-item__content{
  display: flex;
}
/deep/ .input-flex .el-form-item__content .el-input-group{
  margin-right: 18px;
}
/deep/ .input-flex div:nth-child(1){
  margin-right: 8px;
}
/deep/.first-step {
  .el-input__inner {
    width: 100px;
  }
}
/deep/ .last-input {
  .el-input__inner {
    width: 154px;
  }
}
</style>